<template>
    <v-container fluid>
        <div class="about-me">
            <p class="about-me__header">
                About Me
            </p>
            <div
                class="about-me__wrapper"
                ref="observerTarget"
                :class="{ visible: isVisible }"
            >
                <p class="about-me__text">
                    I'm an experienced software developer that's passionate about full-stack development and adding to my toolbelt constantly. I'm a proud career-switcher and bootcamper, two things I take pride in throughout my software career. I love working as a developer full time but I also have interest in developer relations and making sure that each new developer has that same feeling as the industry evolves.        
                </p>
            </div>
        </div>
    </v-container>  
</template>
    
<script>
//import axios from 'axios';
export default {
    name: 'aboutMe',   
    data: () => ({
        instagramPosts: [],
        hostName: {
            igToken: process.env.VUE_APP_IG_TOKEN
        },
        isFetching: true,
        transparent: 'rgba(255, 255, 255, 0)',
        isVisible: false,
    }),
    mounted: async function() {
        //const $vm = this;
        // const fieldData = 'id,caption,media_url,timestamp,media_type,permalink';
        // await axios.get(`https://graph.instagram.com/me/media?access_token=${this.hostName.igToken}&fields=${fieldData}`)
        //     .then(response => {
        //         $vm.instagramPosts = JSON.parse(JSON.stringify(response.data.data))
        //         $vm.instagramPosts = $vm.instagramPosts.slice(0, -7)
        //         $vm.isFetching = false;
        //     })
        //     .catch(function(error) {
        //         console.log(error)
        //     })
           const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(this.$refs.observerTarget);
    }
}
</script>
    
<style lang="scss" scoped>
.about-me {
    background-color: var(--v-cambridgeBlue-base) !important;
    color: white;
    border-radius: 25px;
    padding: 20px;

    &__header {
        font-family: Bebas Neue;
        font-size: 32px;
        margin: 0;
    }

    &__wrapper {
        overflow: hidden;
    }

    &__text {
        margin-top: 20px;
        font-family: IBM Plex Sans;
        font-size: 20px;
        opacity: 0;
        transform: translateY(30px);
        transition: all 0.8s ease-out;
    }
}

.about-me__wrapper.visible .about-me__text {
    opacity: 1;
    transform: translateY(0);
}
</style>